import { BaseService } from 'core/services';
import LocalPatientRouteService from './LocalPatientRouteService';

class LocalPatientService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new LocalPatientRouteService());
    }

    getByPatientKey(id, options = { }) {
        const url = this.routeService.getByPatientKey(id, options);
        return this.apiClient.get(url);
    }

    create(resource) {
        const url = this.routeService.create();
        return this.apiClient.post(url, resource);
    }
    
    async addLocalPatientFromBrightree(resource){
        const url = this.routeService.addLocalPatientFromBrightree(resource);
		const response = await this.apiClient.post(url, resource);
        return response;
    }
}

export default LocalPatientService;
